<template src="./submission-modal.html"></template>

<script lang="ts">
import { defineAsyncComponent, nextTick } from 'vue'
import domUtils from 'util/dom-utils'
import submissionStore from 'store/submission-store'
import Modal from 'objects/modal/Modal.vue'
import WarnCloseModal from 'components/warn-close-modal/WarnCloseModal.vue'


export default {
  name: 'SubmissionModal',
  data() {
    return {
      isConfirmOpen: false,
      isFormLoaded: false,
      popoverMessage: '',
      popoverType: '',
      preventClickOutside: false,
      submissionStore
    }
  },
  components: {
    'tt-modal': Modal,
    'tt-submission-mediator': defineAsyncComponent(
      // tslint:disable-next-line
      () => import(/* webpackChunkName: 'submission' */ 'widgets/submission/SubmissionMediator.vue')
    ),
    'tt-warn-close-modal': WarnCloseModal
  },
  computed: {
    isOpen() {
      return this.submissionStore.isOpen
    },
    poweredByText() {
      return this.submissionStore.poweredByText
    }
  },
  methods: {
    closeConfirm() {
      this.isConfirmOpen = false
      nextTick(() => this.$el.focus())
    },
    closePopover() {
      this.popoverMessage = ''
    },
    closeSubmissionModal() {
      this.isConfirmOpen = false
      submissionStore.fireBackEvent()
    },
    pageLoaded(preventClickOutside = false) {
      this.isFormLoaded = true
      this.preventClickOutside = preventClickOutside
    },
    pageLoading() {
      this.isFormLoaded = false
      // while loading, focus on modal container.  The component being loaded will decide if focus
      // should go elsewhere
      // hard-coded/tightly coupled modal ref name. not great, but unlikely to change
      domUtils.safeFocus(() => this.$refs.modal ? this.$refs.modal.$refs.container : undefined)
    },
    onShowError(providedMessage, closeModal = false, autoClosePopup = true) {
      if (closeModal) {
        const message = providedMessage || this.$msg('flowError.2000')
        import(/* webpackChunkName: 'standalone-popover' */ 'widgets/standalone-popover/standalone-popover-loader').then((popoverLoader) => {
          popoverLoader.default.load({ message, type: 'error' , autoClose: autoClosePopup })
        })
        this.closeSubmissionModal()
        return
      }
      this.popoverMessage = providedMessage
      this.popoverType = 'error'
    },
    onShowPopoverMessage(message, closeModal = false) {
      if (closeModal) {
        import(/* webpackChunkName: 'standalone-popover' */ 'widgets/standalone-popover/standalone-popover-loader').then((popoverLoader) => {
          popoverLoader.default.load({ message })
        })
        this.closeSubmissionModal()
        return
      }
      this.popoverMessage = message
      this.popoverType = 'success'
    },
    outsideClick() {
      if (this.preventClickOutside) {
        this.isConfirmOpen = true
        return
      }
      this.closeSubmissionModal()
    }
  }
}
</script>

<style lang="scss" src="./submission-modal.scss"></style>
